module.exports = __webpack_public_path__ + "images/emoji/kissing_heart.ec2665e2c9c7d3ef55a2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/kissing_heart.png
// module id = X0Ad
// module chunks = 1